import { useContext } from 'react';

import { HistogramDataContext } from '../contexts/HistogramData.context.js';

export const useHistogramData = () => useContext(HistogramDataContext);
